// pages/Home.jsx
import React from "react";

import Seo from "../components/common/Seo";
import Hero from "../components/HomePage/Hero";
import Clients from "../components/HomePage/Clients";
import OurProcess from "../components/HomePage/OurProcess";
import ServicesPreview from "../components/HomePage/ServicesPreview";
import TechnologyStack from "../components/HomePage/TechnologyStack";
import OurWorkSection from "../components/HomePage/worksection";
import Testimonials from "../components/HomePage/Testimonials";
import WhyChooseUs from "../components/HomePage/WhyChooseUs";
import Contact from "../components/HomePage/Contact";

import { SERVICES, SERVICE_CATEGORIES } from "../data/serviceCatalog";
import { SITE_URL, COMPANY, CONTACT } from "../config/site";

const description =
  "DepthLogix builds custom software, web applications, business systems and " +
  "API integrations, from React and .NET builds to ERP, CRM and AI systems " +
  `integration. ${SERVICES.length} services across ${SERVICE_CATEGORIES.length} engineering disciplines.`;

/**
 * Structured data describing the company and what it offers. Built from
 * the real service catalog so it can never describe services that do not
 * exist on the site.
 */
const jsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: COMPANY.name,
  url: `${SITE_URL}/`,
  description,
  email: CONTACT.email,
  telephone: CONTACT.phoneE164,
  logo: `${SITE_URL}/BG/logopng3D.png`,
  areaServed: "Worldwide",
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Software engineering services",
    itemListElement: SERVICE_CATEGORIES.map((category) => ({
      "@type": "OfferCatalog",
      name: category.label,
      itemListElement: SERVICES.filter(
        (service) => service.categoryKey === category.key
      ).map((service) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: service.title,
          description: service.description,
          url: `${SITE_URL}${service.path}`,
        },
      })),
    })),
  },
};

/**
 * Section order follows the question a visitor actually asks, in order:
 * who are you (Hero) → who trusts you (Clients) → what do you build
 * (Services) → can you really build it (Technology) → show me (Work) →
 * how do you work (Process) → why you (Why / Testimonials) → how do I
 * start (Contact).
 *
 * The old page-level opacity fade has been removed: it held the whole
 * homepage at opacity 0 until after hydration, which delayed the largest
 * contentful paint for no visual benefit. Sections now reveal themselves
 * individually as they scroll in.
 */
const Home = () => (
  <>
    <Seo title="Custom Software, Web Applications & Business Systems" description={description} jsonLd={jsonLd} />

    <Hero />
    <Clients />
    <ServicesPreview />
    <TechnologyStack />
    <OurWorkSection />
    <OurProcess />
    <WhyChooseUs />
    <Testimonials />
    <Contact />
  </>
);

export default Home;
